import React from "react";
import classnames from "classnames";
import Select from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import GooglePng from "../../assets/media/analytics/google.png";

import ActiveUser from "../../assets/media/analytics_icons/active_user.png";
import EcoId from "../../assets/media/analytics_icons/eco_id.png";
import UserReviews from "../../assets/media/analytics_icons/user_reviews.png";
import ActiveOpenBankingUsers from "../../assets/media/analytics_icons/open_banking.png";
import TokenValueEarned from "../../assets/media/analytics_icons/token_value_earned.png";
import TokenValueRedeemed from "../../assets/media/analytics_icons/token_value_redeemed.png";
import PollAnswers from "../../assets/media/analytics_icons/poll_answers.png";
import ForumEngagement from "../../assets/media/analytics_icons/forum_engagement.png";
import TicketOpened from "../../assets/media/analytics_icons/tickets_opened.png";
import TicketClosed from "../../assets/media/analytics_icons/tickets_closed.png";
import UserReferrals from "../../assets/media/analytics_icons/user_referrals.png";
import TokenSpendingMarketplace from "../../assets/media/analytics_icons/token_spending_marketplace.png";

import "./index.css";

// NOTE: for static purpose

const BrandAnalytics = {
  active_users: {
    icon: ActiveUser,
    text: "Active\nusers",
    value: 0,
  },
  verified_eco_ids: {
    icon: EcoId,
    text: "Verified\nEcoIDs",
    value: 0,
  },
  user_reviews: {
    icon: UserReviews,
    text: (
      <span>
        User reviews
        <br />
        <img
          src={GooglePng}
          alt="icon"
          style={{ height: 22, marginBottom: 0 }}
        />
      </span>
    ),
    value: 0,
  },
  active_open_banking: {
    icon: ActiveOpenBankingUsers,
    text: "Active open\nbanking users",
    value: 0,
  },
  token_value_earned: {
    icon: TokenValueEarned,
    text: "Token value\nearned",
    value: "£0",
  },
  token_value_redeemed: {
    icon: TokenValueRedeemed,
    text: "Token value\nredeemed",
    value: "£0",
  },
  poll_answers: {
    icon: PollAnswers,
    text: "Poll\nanswers",
    value: 0,
  },
  forum_engagement: {
    icon: ForumEngagement,
    text: "Forum\nengagements",
    value: 0,
  },
  tickets_opened: {
    icon: TicketOpened,
    text: "Tickets\nopened",
    value: 0,
  },
  tickets_closed: {
    icon: TicketClosed,
    text: "Tickets closed\nsuccessfully",
    value: 0,
  },
  user_referrals: {
    icon: UserReferrals,
    text: "User\nreferrals",
    value: 0,
  },
  token_spending_marketplace: {
    icon: TokenSpendingMarketplace,
    text: "Total spending\nin marketplace",
    value: "£0",
  },
};

const EcoAnalytics = {
  active_users: {
    icon: ActiveUser,
    text: "Active\nusers",
    value: "54,421",
  },
  verified_eco_ids: {
    icon: EcoId,
    text: "Verified\nEcoIDs",
    value: "12,312",
  },
  user_reviews: {
    icon: UserReviews,
    text: (
      <span>
        User reviews
        <br />
        <img
          src={GooglePng}
          alt="icon"
          style={{ height: 22, marginBottom: 0 }}
        />
      </span>
    ),
    value: "7,765",
  },
  active_open_banking: {
    icon: ActiveOpenBankingUsers,
    text: "Active open\nbanking users",
    value: 765,
  },
  token_value_earned: {
    icon: TokenValueEarned,
    text: "Token value\nearned",
    value: "£2.28m",
  },
  token_value_redeemed: {
    icon: TokenValueRedeemed,
    text: "Token value\nredeemed",
    value: "£1.76m",
  },
  poll_answers: {
    icon: PollAnswers,
    text: "Poll\nanswers",
    value: "62,331",
  },
  forum_engagement: {
    icon: ForumEngagement,
    text: "Forum\nengagements",
    value: "10,216",
  },
  tickets_opened: {
    icon: TicketOpened,
    text: "Tickets\nopened",
    value: "2,032",
  },
  tickets_closed: {
    icon: TicketClosed,
    text: "Tickets closed\nsuccessfully",
    value: "1,735",
  },
  user_referrals: {
    icon: UserReferrals,
    text: "User\nreferrals",
    value: 275,
  },
  token_spending_marketplace: {
    icon: TokenSpendingMarketplace,
    text: "Total spending\nin marketplace",
    value: "£567k",
  },
};

class SuperAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      brand: {},
      brands: [],
      loading: true,
      brandTab: 0,
      ecoTab: 0,
      selectedBrand: null,
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      const umbrellaBrand = Number(localStorage.getItem("umbrella"));
      Firebase.getAllBrands((res) => {
        let brands = res
          .map((item, index) => {
            let new_item = item;
            new_item.id = index;
            return new_item;
          })
          .filter((item) => item && !item.deactive);
        brands.sort(function (a, b) {
          var textA = a.name.toUpperCase();
          var textB = b.name.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        if (localStorage.getItem("umbrella")) {
          const parentBrand = brands.find(
            (obj) => obj && obj.id === umbrellaBrand
          );
          brands = brands.filter((obj) => obj.parent === umbrellaBrand);
          this.setState({ brand: parentBrand });
        }
        this.setState({ brands, loading: false });
      });
    }
  }

  onTabChanged = (name, value) => () => {
    this.setState({
      [name]: value,
    });
  };

  handleChangeBrand = (selectedBrand) => {
    this.setState({ selectedBrand });
  };

  renderItem = (item) => (
    <div className="item-container">
      <img src={item.icon} alt="icon" />
      <p className="item-name">{item.text}</p>
      <p className="item-value">{item.value}</p>
    </div>
  );

  render() {
    const {
      username,
      role,
      brand,
      loading,
      brandTab,
      ecoTab,
      selectedBrand,
      brands,
    } = this.state;
    return (
      <div id="page-contaienr">
        <Header username={username} role={role} logo={brand && brand.logo} />
        <main id="main-container">
          <div className="super-analytics-content">
            {loading && (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <div className="analytics-container">
                <div className="brand-anlaytics">
                  <div className="analytics-header">
                    <div className="active-brand-container">
                      <p>Active brand data</p>
                      <Select
                        value={selectedBrand}
                        onChange={this.handleChangeBrand}
                        options={(brands || []).map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))}
                      />
                    </div>
                    {/* <div className="mode-btn-group">
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: brandTab === 0,
                        })}
                        onClick={this.onTabChanged("brandTab", 0)}
                      >
                        Total
                      </div>
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: brandTab === 1,
                        })}
                      >
                        This month
                      </div>
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: brandTab === 2,
                        })}
                      >
                        Today
                      </div>
                    </div> */}
                  </div>
                  <div className="items-container">
                    {this.renderItem(BrandAnalytics.active_users)}
                    {this.renderItem(BrandAnalytics.verified_eco_ids)}
                    {this.renderItem(BrandAnalytics.user_reviews)}
                    {this.renderItem(BrandAnalytics.active_open_banking)}
                  </div>
                  <div className="items-container">
                    {this.renderItem(BrandAnalytics.token_value_earned)}
                    {this.renderItem(BrandAnalytics.token_value_redeemed)}
                    {this.renderItem(BrandAnalytics.poll_answers)}
                    {this.renderItem(BrandAnalytics.forum_engagement)}
                  </div>
                  <div className="items-container">
                    {this.renderItem(BrandAnalytics.tickets_opened)}
                    {this.renderItem(BrandAnalytics.tickets_closed)}
                    {this.renderItem(BrandAnalytics.user_referrals)}
                    {this.renderItem(BrandAnalytics.token_spending_marketplace)}
                  </div>
                </div>
                <div className="eco-analytics">
                  <div className="analytics-header">
                    <p style={{ marginRight: "20px" }}>
                      Total Ecosystem Figures
                    </p>
                    {/* <div className="mode-btn-group">
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: ecoTab === 0,
                        })}
                        onClick={this.onTabChanged("ecoTab", 0)}
                      >
                        Total
                      </div>
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: ecoTab === 1,
                        })}
                      >
                        This month
                      </div>
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: brandTab === 2,
                        })}
                      >
                        Today
                      </div>
                    </div> */}
                  </div>
                  <div className="items-container">
                    {this.renderItem(EcoAnalytics.active_users)}
                    {this.renderItem(EcoAnalytics.verified_eco_ids)}
                    {this.renderItem(EcoAnalytics.user_reviews)}
                    {this.renderItem(EcoAnalytics.active_open_banking)}
                  </div>
                  <div className="items-container">
                    {this.renderItem(EcoAnalytics.token_value_earned)}
                    {this.renderItem(EcoAnalytics.token_value_redeemed)}
                    {this.renderItem(EcoAnalytics.poll_answers)}
                    {this.renderItem(EcoAnalytics.forum_engagement)}
                  </div>
                  <div className="items-container">
                    {this.renderItem(EcoAnalytics.tickets_opened)}
                    {this.renderItem(EcoAnalytics.tickets_closed)}
                    {this.renderItem(EcoAnalytics.user_referrals)}
                    {this.renderItem(EcoAnalytics.token_spending_marketplace)}
                  </div>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    );
  }
}

export default SuperAnalytics;



// WEBPACK FOOTER //
// ./src/screens/SuperAnalytics/index.js